import React from 'react';
import { IconMinus } from '@americanexpress/dls-icons';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { motion } from 'framer-motion';
import styles from '../styles/CreateWishlistModal.scss';
import { getCityAndLocation } from '../utils/getCityAndLocation';
import { MODULE_NAME } from '../utils/constants';

export const CreateWishlistModal = ({ setCreateModalIsOpen, saveSelectedHotels }) => {
  const intl = useIntl();
  const selectedHotels = useSelector((state) => state.getIn(['modules', MODULE_NAME, 'selectedHotels'])).toJS();
  return (
    <>
      <motion.div
        className={styles.popupOverlay}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 0.1 } }}
        exit={{ opacity: 0 }}
        onClick={() => setCreateModalIsOpen(false)}
      />
      <motion.div
        className={styles.popupContent}
        data-testid="popupModal"
        role="dialog"
        aria-modal="true"
        aria-label="create wishlist modal"
        initial={{ y: '100%' }}
        animate={{ y: 0 }}
        exit={{ y: '100%' }}
        transition={{ type: 'spring', stiffness: 300, damping: 30 }}
        drag="y"
        dragElastic={0.2}
        dragConstraints={{ top: 0 }}
        onDragEnd={(e, info) => {
          if (info.offset.y > 100 || info.velocity.y > 100) {
            setCreateModalIsOpen(false);
          }
        }}
      >
        <div
          className="flex flex-column width-full height-full text-align-center position-relative"
        >
          <div
            className="position-absolute position-absolute-tr"
          >
            <button
              type="button"
              style={{ height: '28px', width: '28px' }}
              onClick={() => setCreateModalIsOpen(false)}
            >
              <IconMinus
                color="brand"
                size="md"
                isFilled={false}
                title="Close create wishlist popup"
                titleId="close-create-modal"
              />
            </button>
          </div>
          <div
            className="heading-3"
            style={{
              fontSize: '1.25rem',
              padding: '.625rem 0',
            }}
          >{intl.formatMessage({ id: 'createModal.title' })}
          </div>
          <div style={{ paddingBottom: '.825rem' }}>Tuscany Vineyards ({selectedHotels.length})</div>
          <div
            className={styles.grid}
            /* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- scrollable */
            tabIndex={0}
            aria-label="Selected hotels"
          >
            {selectedHotels.map((hotel) => {
              const {
                hotelId, address, name, media,
              } = hotel;
              const { title, url } = media[0] || {};

              const { city, location } = getCityAndLocation(address);
              return (
                <div
                  key={hotelId}
                  className="text-align-left"
                >
                  <div
                    className="flex flex-align-center radius-container pad-1-b"
                    style={{ aspectRatio: '1/1' }}
                  >
                    <img
                      src={url}
                      className="radius-container"
                      alt={title}
                      style={{ objectFit: 'cover', height: '100%', width: '100%' }}
                      data-testid="hotel-image"
                    />
                  </div>
                  <div
                    className={`${styles.hotelPopupName} body-small-bold`}
                  >
                    {name}
                  </div>
                  <div className={`${styles.locationGrayFont} body-xsmall`}>
                    {city}, {location}
                  </div>
                </div>
              );
            })}
          </div>
          <div className={styles.popupFooterContainer}>
            <button
              type="button"
              data-testid="saveWishlistButton"
              className={`${styles.completeWishlistButton} heading-2`}
              onClick={saveSelectedHotels}
            >
              {intl.formatMessage({ id: 'createModal.saveWishlistButton' })}
            </button>
            <div className={`${styles.popupDisclaimer} body-xsmall`}>
              {intl.formatMessage({ id: 'createModal.terms' })}
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
};

CreateWishlistModal.propTypes = {
  setCreateModalIsOpen: PropTypes.func.isRequired,
  saveSelectedHotels: PropTypes.func.isRequired,
};
